import template from './sw-cms-toolbar.html.twig';
import './sw-cms-toolbar.scss';

/**
 * @package buyers-experience
 */
// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default {
    template,
};
